import './modules/productCalculator.js'
import './modules/featureCalculator.js'
